import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { finalize } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-confirmar-email',
    templateUrl: './confirmar-email.component.html',
    styleUrls: ['./confirmar-email.component.css'],
    imports: [FormsModule, ReactiveFormsModule, CommonModule]
})
export class ConfirmarEmailComponent implements OnInit {

  loading: boolean = false;

  hash: string = "";
  token: string = "";
  
  msgErro: string = null;
  
  constructor(private router: Router, private route: ActivatedRoute, private http: HttpClient) {
    
    this.route.params.subscribe(params => {
      
      if(params['hash']==''){
        alert('Parâmetro inválido');
        this.router.navigate(['/autenticacao/login']);
      }else{
        this.hash = params['hash'];
      }

    });
  }
  
  ngOnInit() {

  }

  validarToken() {
    
    this.loading = true;

    this.http
    .post(`${environment.apiURL}/Aberto/ConfirmarEmail/ValidarToken`, {hash: this.hash, token: this.token})
    .pipe(
      finalize(()=> {this.loading = false})
    )
    .subscribe(
      (status: boolean) => {

        if(status){
          alert("Validação Confirmada !");
          this.router.navigate(['/autenticacao/login']);
        }else{
          alert("Código de verificação inválido");
        }
        
      },
      httpError => {
        console.error(httpError);
        this.msgErro = httpError.error.ex;
      }
    );

  }

}
